export const enum Anchor {
    PORTFOLIO = 'portfolio',
    ABOUT_US = 'aboutus',
    CONTACT_US = 'contact-us',
    STRATEGY = 'strategy',
    SERVICES = 'services'
}